
import React from 'react';
import { string } from 'prop-types';

import cx from 'classnames';
import s from './LoadingState.css';


// @TODO we can make this more robust in terms of having the component respond to an isLoading prop
// handling errors and that kind of thing. For now, simply displaying an animation will suffice.

/*
@params:
context - plain string to target a page/component for specific styling
*/
const LoadingState = ({ context, label = 'Loading' }) =>
  <div
    className={cx(s.component, s[context])}
    role="status"
    aria-label={label}
  >
    <div className={s.threeDotsBouncing}></div>
    <div className={s.threeDotsBouncing}></div>
    <div className={s.threeDotsBouncing}></div>
    <span className={s.visuallyHidden}>{label}</span>
  </div>;

LoadingState.propTypes = {
  context: string,
  label: string,
};

export default LoadingState;



// WEBPACK FOOTER //
// ./src/components/LoadingState/LoadingState.js